export default __webpack_public_path__ + "static/media/paisley.07197c72.jpg";